import { useEffect, useState } from "react";
import { Moon, Sun, Terminal } from "lucide-react";
import { Button } from "./ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

type Theme = "light" | "dark" | "hacker";

function applyTheme(theme: Theme) {
  const root = document.documentElement;
  root.classList.remove("dark", "theme-hacker");
  if (theme === "dark") root.classList.add("dark");
  if (theme === "hacker") root.classList.add("theme-hacker", "dark");
  localStorage.setItem("hideaway-theme", theme);
}

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(() => {
    const stored = localStorage.getItem("hideaway-theme") as Theme | null;
    if (stored === "light" || stored === "dark" || stored === "hacker") return stored;
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  });

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const cycle = () => {
    setTheme((prev) => (prev === "light" ? "dark" : prev === "dark" ? "hacker" : "light"));
  };

  const icon =
    theme === "light" ? <Sun className="h-4 w-4" /> : theme === "dark" ? <Moon className="h-4 w-4" /> : <Terminal className="h-4 w-4 text-success" />;
  const nextLabel =
    theme === "light" ? "Dark mode" : theme === "dark" ? "Hacker mode" : "Light mode";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          onClick={cycle}
          aria-label={`Switch to ${nextLabel}`}
          className="hover:bg-muted/50 transition-colors"
        >
          {icon}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{nextLabel}</TooltipContent>
    </Tooltip>
  );
}
